import { render, staticRenderFns } from "./module_c.vue?vue&type=template&id=4736f09f&scoped=true&"
import script from "./module_c.vue?vue&type=script&lang=js&"
export * from "./module_c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4736f09f",
  null
  
)

export default component.exports